import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectModules, selectTotal, selectPage, selectLimit } from '../selectors/modules.selector';
import { modulesActions } from '../actions/modules.actions';
import { PaginationParams } from '../types';

@Injectable({
    providedIn: 'root',
})
export class ModulesFacade {
    private store = inject(Store);

    readonly loaded$ = this.store.select(selectLoaded);
    readonly loadedNonNullable$ = this.store.select(selectLoaded).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = this.store.select(selectLoading);
    readonly modules$ = this.store.select(selectModules);
    readonly total$ = this.store.select(selectTotal);
    readonly page$ = this.store.select(selectPage);
    readonly limit$ = this.store.select(selectLimit);

    readonly modules = this.store.selectSignal(selectModules);
    readonly total = this.store.selectSignal(selectTotal);
    readonly loading = this.store.selectSignal(selectLoading);
    readonly page = this.store.selectSignal(selectPage);
    readonly limit = this.store.selectSignal(selectLimit);

    getModules(value: PaginationParams): void {
        this.store.dispatch(modulesActions.getModules({ value }));
    }

    clear(): void {
        this.store.dispatch(modulesActions.clear());
    }
}
